import { useDateFormatter } from '@mint-lib/formatting-hooks';

const StaticDateSpan = ({
  date,
  options,
}: {
  date?: number | string | Date;
  options?: {
    format?: string;
    /*   en-GB locale
     *   - `P`: 29/05/1453
     *   - `PP`: May 29 1453
     *   - `PPP`: May 29 1453
     *   - `PPPP`: Sunday, May 29 1453
     *
     *   en-US locale
     *   - `P`: 05/29/1453
     *   - `PP`: May 29, 1453
     *   - `PPP`: May 29th, 1453
     *   - `PPPP`: Sunday, May 29th, 1453
     *
     *   - or any other format
     */
  };
}) => {
  const { formatDate } = useDateFormatter();

  if (date == null) {
    return null;
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  const res = formatDate(parsedDate, options?.format);

  return <span>{res}</span>;
};

export default StaticDateSpan;
